import moment from "moment";

export const GetPreviousDate = (previousHour: number) => {
    var currentDate = new Date();
    currentDate.setHours(currentDate.getHours() - previousHour);
    return currentDate;
}

export const ConvertToUTC = (date: Date) => {
    const year = date.getFullYear(),
        month = (date.getMonth() + 1).toString().padStart(2, '0'),
        day = (date.getDate()).toString().padStart(2, '0'),
        hour = (date.getHours()).toString().padStart(2, '0'),
        minute = (date.getMinutes()).toString().padStart(2, '0'),
        second = (date.getSeconds()).toString().padStart(2, '0');
    const dateString = `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    return moment.utc(dateString).toDate();
}